<template>
  <div class="breakdown">
    <div v-if="overview.opening !== null" class="bd-row bd-static">
      <span class="bd-label bd-strong">{{ $t("finance_opening_balance") }}</span>
      <span class="bd-value bd-strong">{{ fmt(overview.opening) }}</span>
      <span />
    </div>

    <div
      v-for="row in overview.rows"
      :key="row.key"
      class="bd-row"
      :class="{ 'bd-clickable': !readonly }"
      :role="readonly ? null : 'button'"
      :tabindex="readonly ? null : 0"
      @click="!readonly && $emit('line-click', row)"
      @keyup.enter="!readonly && $emit('line-click', row)"
    >
      <span class="bd-label">
        <span :class="{ 'bd-link': !readonly }">{{ translate(row.label) }}</span>
        <v-tooltip v-if="row.isCash" top max-width="320">
          <template #activator="{ on, attrs }">
            <v-icon x-small class="ml-1" v-bind="attrs" v-on="on" @click.stop>mdi-information-outline</v-icon>
          </template>
          <span>{{ $t("finance_cash_tooltip") }}</span>
        </v-tooltip>
      </span>
      <span class="bd-value" :style="{ color: row.color }">{{ fmt(row.value, true) }}</span>
      <v-icon v-if="!readonly" x-small class="bd-chevron">mdi-chevron-right</v-icon>
      <span v-else />
    </div>

    <div v-if="overview.closing !== null" class="bd-row bd-total">
      <span class="bd-label">{{ $t("finance_closing_balance") }}</span>
      <span class="bd-value">{{ fmt(overview.closing) }}</span>
      <span />
    </div>
  </div>
</template>

<script>
import { formatMoney } from "./constants";

// Razrada perioda ("Obračun za period") - isti prikaz na Zarada i u detalju
// Obračuna. Svaki red (osim početnog/krajnjeg stanja) je kliknut -> redovi iz kojih je nastao.
export default {
  name: "StatementBreakdown",

  props: {
    overview: { type: Object, required: true },
    // Bez klika na redove (npr. unutar forme za evidenciju plaćanja).
    readonly: { type: Boolean, default: false },
  },

  methods: {
    fmt(value, signed) {
      return formatMoney(value, this.overview.currency, { signed });
    },
  },
};
</script>

<style scoped>
.bd-row {
  display: grid;
  grid-template-columns: 1fr auto 16px;
  align-items: center;
  gap: 10px;
  padding: 11px 6px;
  border-top: 1px solid #eceef2;
  font-size: 0.92rem;
}

.bd-clickable {
  cursor: pointer;
}

.bd-clickable:hover,
.bd-clickable:focus {
  background: #f6f8fb;
  outline: none;
}

.bd-link {
  text-decoration: underline;
}

.bd-strong {
  font-weight: 700;
}

.bd-value {
  font-weight: 600;
  white-space: nowrap;
}

.bd-chevron {
  color: #9aa4b2;
}

.bd-total {
  border-top: 2px solid rgba(0, 0, 0, 0.87);
  font-weight: 800;
}

.bd-total .bd-value {
  font-weight: 800;
}
</style>
